let SortDirection;

(function (SortDirection) {
  SortDirection["asc"] = "Ascending";
  SortDirection["dsc"] = "Descending";
})(SortDirection || (SortDirection = {}));

let FilterType;

(function (FilterType) {
  FilterType["string"] = "string";
  FilterType["number"] = "number";
})(FilterType || (FilterType = {}));

export { FilterType, SortDirection };
//# sourceMappingURL=types.js.map
